import { motion } from "framer-motion";
import PageHeader from "../components/PageHeader";
import { GALLERY } from "../data/content";

const spans = [
  "md:col-span-8 md:row-span-2",
  "md:col-span-4",
  "md:col-span-4",
  "md:col-span-5",
  "md:col-span-3",
  "md:col-span-4",
];

export default function Gallery() {
  return (
    <div data-testid="gallery-page">
      <PageHeader overline="The Record" lines={["Gallery"]} sub="Moments of glory, consecration and covenant." />

      <section className="px-6 md:px-10 max-w-[1600px] mx-auto pb-32">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-4 auto-rows-[240px]">
          {GALLERY.map((src, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, scale: 0.96 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: (i % 3) * 0.1 }}
              className={`group relative overflow-hidden border border-border p-2 bg-muted/30 ${spans[i % spans.length]}`}
              data-testid={`gallery-item-${i}`}
            >
              <div className="w-full h-full overflow-hidden">
                <img
                  src={src}
                  alt={`Gallery ${i + 1}`}
                  className="w-full h-full object-cover grayscale group-hover:grayscale-0 scale-100 group-hover:scale-110 transition-all duration-700"
                />
              </div>
            </motion.div>
          ))}
        </div>
      </section>
    </div>
  );
}
